import React from "react";
import MainLayout from "./main";
import ProtectedRoute from "../components/auth/ProtectedRoute";

export default function AuthenticatedLayout({ children }) {
  return (
    <ProtectedRoute>
      <MainLayout>{children}</MainLayout>
    </ProtectedRoute>
  );
}
